import React, { useState, useEffect, useCallback } from 'react'
import TextField from '@mui/material/TextField';
import { FaUserAlt } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { MdFamilyRestroom } from "react-icons/md";
import { FaReceipt } from "react-icons/fa6";
import Button from '@mui/material/Button';
import { FaCalendar, FaClock } from "react-icons/fa";
import { MdError } from "react-icons/md";
import { Tooltip } from '@mui/material';
import dayjs from 'dayjs';
import { useAuth } from '../provider/auth';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FaSuitcaseRolling } from "react-icons/fa";
import { MdPaid } from "react-icons/md";
import ShowBookingModal from '../components/ShowBookingModal';
import { GiTennisCourt } from "react-icons/gi";
import { RiMoneyEuroCircleFill } from "react-icons/ri";
import { API_BASE_URL } from '../App.js';

const Account = () => {
    const { user } = useAuth();
    const [changePassword, setChangePassword] = useState(false)
    const [profile, setProfile] = useState({});
    const [upcomingBookings, setUpcomingBookings] = useState([]);
    const [pastBookings, setPastBookings] = useState([]);
    const [showAllBookings, setShowAllBookings] = useState(false);
    const [guestBookings, setGuestBookings] = useState([]);
    const [showGuestBookings, setShowGuestBookings] = useState(false);
    const [booking, setBooking] = useState([]);
    const [showBooking, setShowBooking] = useState(false);
    const [values, setValues] = useState({ oldPassword: "", newPassword: "", newPassword1: "" });
    const [players, setPlayers] = useState([]);

    useEffect(() => {
        axios
            .get(`${API_BASE_URL}/api/players`, {
            })
            .then((response) => {
                setPlayers(response.data);
            })
            .catch((error) => {
            });
    }, []);

    const handleClick = (booking) => {
        setBooking(booking);
        setShowBooking(true);
    };

    const handleChangePassword = (values) => {
        if (values.newPassword === values.newPassword1) {

            const passwords = {
                currentPassword: values.oldPassword,
                newPassword: values.newPassword
            }

            axios
                .post(`${API_BASE_URL}/api/change-password`, passwords)
                .then((response) => {
                    toast.success(response.data.message);
                    setValues({ oldPassword: "", newPassword: "", newPassword1: "" });
                    setChangePassword(false);
                })
                .catch((error) => {
                    toast.error(error.response?.data?.message || "Fehler beim Passwort ändern")
                });
        } else {
            toast.error("Passwörter stimmen nicht überein")
        }
    }

    const fetchBookings = useCallback(() => {
        axios
            .get(`${API_BASE_URL}/api/${user.playerId}/bookings`)
            .then((response) => {
                const now = new Date();
                const upcoming = response.data
                    .filter(booking => new Date(booking.endTime) > now)
                    .sort((a, b) => new Date(b.startTime) - new Date(a.startTime));

                const past = response.data
                    .filter(booking => new Date(booking.endTime) <= now)
                    .sort((a, b) => new Date(b.startTime) - new Date(a.startTime));

                const guest = response.data
                    .filter(booking => booking.partners.includes(profile.guestId))
                    .sort((a, b) => new Date(b.startTime) - new Date(a.startTime));

                setUpcomingBookings(upcoming);
                setPastBookings(past);
                setGuestBookings(guest);

            })
            .catch((error) => {
            });
    }, [user.playerId, profile.guestId]);

    const handleClose = (value) => {
        if (value) {
            fetchBookings();
        }
        setShowBooking(false);
    }

    useEffect(() => {
        axios
            .get(`${API_BASE_URL}/api/profile`, {
            })
            .then((response) => {
                setProfile(response.data);
            })
            .catch((error) => {
            });
    }, []);

    useEffect(() => {
        fetchBookings();
    }, [fetchBookings]);



    if (!profile.player) {
        // Render nothing or a loading indicator if profile.player is not available
        return <div>Loading...</div>;
    }

    return (
        <div>
            <div className='row'>
                <div className='col-md-4'>
                    <div className='bg-b-c rounded px-2 pb-3 pt-3 shadow'>
                        <div className='mx-3'>
                            <div className='text-center py-3 fs-5 fw-semibold text-danger'>Meine Daten</div>
                            <div className='text-center mt-2 fs-5 fw-semibold'><FaUserAlt size={30} /></div>
                            <div className='text-center fw-semibold pt-2'>{profile.player.firstName} {profile.player.lastName}</div>
                            <div className='row justify-content-center align-items-center py-1'>
                                <div className='col-auto fs-5 text-end fw-semibold'><IoMdMail /></div>
                                <div className='col-auto fs-7 pt-1'>{profile.player.email}</div>
                            </div>
                            {profile.familyMembers.length > 0 && <>
                                <div className='text-centerinfotext fw-semibold fs-4 text-center border-bottom mx-5'><MdFamilyRestroom size={26} /></div>
                                <div className='text-center '>
                                    {profile.familyMembers.map((member, index) => (
                                        <div className='my-1 fs-7' key={index}>{member.firstName} {member.lastName}</div>
                                    ))}
                                </div>
                            </>
                            }
                            <div className='text-center mt-4 pb-1 border-bottom mx-5 infotext fw-semibold'>BUCHUNGEN</div>
                            <div className='row align-items-center justify-content-center py-1 pt-2'>
                                <div className={`col-4 fw-semibold text-center px-3 pt-2 arrow ${!showGuestBookings && !showAllBookings && "text-dark"}`} title="Aktuelle Buchungen anzeigen" onClick={() => { setShowGuestBookings(false); setShowAllBookings(false) }}>
                                    <FaReceipt size={25} />
                                    <div className='pt-1'>{upcomingBookings.length}/{profile.player.bookingTimes}</div>
                                    <div className='pt-1 fs-7'>AKTUELL</div>
                                </div>
                                <div className={`col-4 fw-semibold text-center px-3 pt-2 arrow ${showGuestBookings && "text-dark"}`} title="Gastspiele anzeigen" onClick={() => setShowGuestBookings(!showGuestBookings)}>
                                    <FaSuitcaseRolling size={30} />
                                    <div className='pt-1'>{guestBookings.length}</div>
                                    <div className='pt-1 fs-7'>GAST</div>
                                </div>

                            </div>
                            {!changePassword && (
                                <div className='text-center mt-4 fw-semibold forgot-password' onClick={() => setChangePassword(true)}>PASSWORT ÄNDERN</div>
                            )}
                            {changePassword &&
                                <div className='pt-3'>
                                    <div className='my-2 text-center'>
                                        <TextField
                                            id="oldPassword"
                                            label="altes Passwort"
                                            size="small"
                                            variant="outlined"
                                            type="password"
                                            className='bg-white-25 rounded'
                                            onChange={e => setValues({ ...values, [e.target.id]: e.target.value })}
                                            sx={{ '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#e53935' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: '#e53935' } } }}

                                        />
                                    </div>
                                    <div className='my-2 text-center'>
                                        <TextField
                                            id="newPassword"
                                            label="neues Passwort"
                                            size="small"
                                            variant="outlined"
                                            type="password"
                                            className='bg-white-25 rounded'
                                            onChange={e => setValues({ ...values, [e.target.id]: e.target.value })}
                                            sx={{ '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#e53935' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: '#e53935' } } }}

                                        />
                                    </div>
                                    <div className='my-2 text-center'>
                                        <TextField
                                            id="newPassword1"
                                            label="neues Passwort wiederholen"
                                            size="small"
                                            variant="outlined"
                                            type="password"
                                            className='bg-white-25 rounded'
                                            onChange={e => setValues({ ...values, [e.target.id]: e.target.value })}
                                            sx={{ '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#e53935' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: '#e53935' } } }}

                                        />
                                    </div>
                                    <div className='text-center my-4'>
                                        <Button variant="contained" color="error" onClick={() => handleChangePassword(values)}>Passwort ändern</Button>
                                        <div className='text-center mt-3 fw-semibold forgot-password' onClick={() => setChangePassword(false)}>Schließen</div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className='col-md'>

                    <div className='bg-b-c rounded px-3 pb-3 pt-3 shadow'>
                        <div className='mx-3'>
                            <div className='text-center py-3 fs-5 fw-semibold text-danger'>
                                {showGuestBookings ? "Meine Gastbuchungen" : showAllBookings ? "Alle Buchungen" : "Aktuelle Buchungen"}
                            </div>
                            <div className='row my-2 align-items-center py-2 text-center'>
                                <div className='col-4 infotext'><FaCalendar size={22} /></div>
                                <div className="col-5 infotext">
                                    <FaClock size={22} />
                                </div>
                                {showGuestBookings ? <div className='col-3 infotext'><MdPaid size={25} /></div> : <div className='col-3 infotext'><GiTennisCourt size={25} /></div>}
                            </div>
                            {showGuestBookings ? (
                                <>
                                    {guestBookings.length !== 0 ? guestBookings.map((booking, index) => (
                                        <div
                                            key={index}
                                            className={`row my-1 align-items-center py-3 text-center fw-semibold shadow-sm rounded-5 booking ${booking.status === 1 ? 'opacity-75' : ''}`}
                                            onClick={() => handleClick(booking)}
                                            style={booking.status === 1 ? { backgroundColor: '#fff5f5' } : {}}
                                        >
                                            <div className='col-4 d-flex align-items-center justify-content-center'>
                                                {booking.status === 1 && (
                                                    <Tooltip title={`Storniert durch Event: ${booking.cancelledByEventId?.name || 'Unbekannt'}`}>
                                                        <span style={{ marginRight: '4px', cursor: 'help' }}>
                                                            <MdError color="#d32f2f" size={18} />
                                                        </span>
                                                    </Tooltip>
                                                )}
                                                {dayjs(booking.startTime).format("DD.MM.YY")}
                                            </div>
                                            <div className="col-5">
                                                {dayjs(booking.startTime).format("HH:mm")}

                                                <span className="d-none d-md-inline">
                                                    {" - "}
                                                    {dayjs(booking.endTime).format("HH:mm")} Uhr
                                                </span>
                                            </div>
                                            <div className='col-3 '>
                                                {booking.guestPlayerpayed
                                                    ? <RiMoneyEuroCircleFill className="icon-paid" size={22} title="Bezahlt" />
                                                    : <RiMoneyEuroCircleFill className="icon-unpaid" size={22} title="offen" />}
                                            </div>
                                        </div>
                                    )) :
                                        <div className='text-center my-3 fs-6'>
                                            Du hast keine Gäste Buchungen
                                        </div>
                                    }
                                    <div className='text-center forgot-password pt-3' onClick={() => setShowGuestBookings(!showGuestBookings)}>
                                        ZURÜCK
                                    </div>
                                </>
                            ) : (
                                <>
                                    {upcomingBookings.length !== 0 ? upcomingBookings.map((booking, index) => (
                                        <div
                                            key={index}
                                            className={`row my-1 align-items-center shadow-sm rounded-5 booking py-3 text-center fw-semibold ${booking.status === 1 ? 'opacity-75' : ''}`}
                                            onClick={() => handleClick(booking)}
                                            style={booking.status === 1 ? { backgroundColor: '#fff5f5' } : {}}
                                        >
                                            <div className='col-4 d-flex align-items-center justify-content-center fs-7'>
                                                {booking.status === 1 && (
                                                    <Tooltip title={`Storniert durch Event: ${booking.cancelledByEventId?.name || 'Unbekannt'}`}>
                                                        <span style={{ marginRight: '4px', cursor: 'help' }}>
                                                            <MdError color="#d32f2f" size={18} />
                                                        </span>
                                                    </Tooltip>
                                                )}
                                                {dayjs(booking.startTime).format("DD.MM.YY")}
                                            </div>
                                            <div className="col-5 fs-7">
                                                {dayjs(booking.startTime).format("HH:mm")}

                                                <span className="d-none d-md-inline">
                                                    {" - "}
                                                    {dayjs(booking.endTime).format("HH:mm")} Uhr
                                                </span>
                                            </div>
                                            <div className='col-3 fs-7'>{booking.courtId}</div>
                                        </div>
                                    )) :
                                        <div className='text-center my-3 fs-6'>
                                            Du hast keine bevorstehenden Buchungen
                                        </div>
                                    }
                                    {showAllBookings && pastBookings.map((booking, index) => (
                                        <div
                                            key={index}
                                            className={`row my-1 align-items-center shadow-sm rounded-5 booking py-3 text-center ${booking.status === 1 ? 'opacity-75' : ''}`}
                                            onClick={() => handleClick(booking)}
                                            style={booking.status === 1 ? { backgroundColor: '#fff5f5' } : {}}
                                        >
                                            <div className='col-4 d-flex align-items-center justify-content-center fs-7'>
                                                {booking.status === 1 && (
                                                    <Tooltip title={`Storniert durch Event: ${booking.cancelledByEventId?.name || 'Unbekannt'}`}>
                                                        <span style={{ marginRight: '4px', cursor: 'help' }}>
                                                            <MdError color="#d32f2f" size={18} />
                                                        </span>
                                                    </Tooltip>
                                                )}
                                                {dayjs(booking.startTime).format("DD.MM.YY")}
                                            </div>
                                            <div className="col-5 col-lg-4 fs-7">
                                                {dayjs(booking.startTime).format("HH:mm")}

                                                <span className="d-none d-md-inline">
                                                    {" - "}
                                                    {dayjs(booking.endTime).format("HH:mm")} Uhr
                                                </span>
                                            </div>
                                            <div className='col-3 fs-7'>{booking.courtId}</div>
                                        </div>
                                    ))}
                                    {pastBookings.length !== 0 && (
                                        <div className='text-center forgot-password pt-3' onClick={() => setShowAllBookings(!showAllBookings)}>
                                            {showAllBookings ? "WENIGER ANZEIGEN" : showGuestBookings ? "AKTUELLE ANZEIGEN" : "ALLE ANZEIGEN"}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {showBooking && <ShowBookingModal show={showBooking} onHide={handleClose} booking={booking} players={players} />}
        </div >
    )
}

export default Account;